export enum EnableItemStatus {
  neutral = 'neutral',
  active = 'success',
}

export interface EnableItemProps {
  className?: string;
  description: string;
  enabled: boolean;
  status?: EnableItemStatus;
  testId?: string;
}
